import { AdaButton, useBoolean } from '@betrybe/ada-react';
import * as Sentry from '@sentry/browser';

import { styled } from '@/configs/stitches.config';
import { useClient } from '@/hooks';
import { useMscPipeline } from '@/services/pre-enrollment';
import StatesEnum from '@/utils/enums/StatesEnum';

const Root = styled('div', {
  display: 'flex',
  gap: '$spacingMd',
  padding: '$spacingSm',
  paddingLeft: '$spacingXsm',
  marginTop: '$spacing2xl',
  border: '$borderColorMedium 1px solid',
});

const DecorationBar = styled('div', {
  width: '1rem',
  backgroundColor: '$textColorSecondary',
  borderRadius: '$borderRadiusMd',
});

const TextContainer = styled('div', {
  display: 'flex',
  gap: '$spacingXsm',
  alignItems: 'center',
  paddingBlock: '$spacingSm',
});

const Text = styled('p', {
  font: '$bodyRegular',
  display: 'inline-block',
});

const ChangePaymentMethodLink = styled('a', {
  color: '$textColorInteractionPrimaryActive',
});

const CloseButton = styled(AdaButton, {});

const Alert: React.FC = () => {
  const { changeMscPipeline } = useMscPipeline();
  const [isVisible, { setFalse: close }] = useBoolean(true);
  const { clientId, mscPipelineId, selectionProcessId, stateMachineVersion } =
    useClient();
  const isV3 = stateMachineVersion === 'V3';

  const handleChangePaymentMethod = async (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    event.preventDefault();
    try {
      await changeMscPipeline({
        mscPipelineId,
        selectionProcessId,
        event: StatesEnum.CHANGE_PAYMENT_METHOD,
      });

      window.location.href = process.env.REACT_APP_EDUCATION_URL;
    } catch (error) {
      Sentry.setUser({ id: clientId });
      Sentry.captureException(error);
    }
  };

  if (!isVisible || !isV3) return null;

  return (
    <Root>
      <DecorationBar />
      <TextContainer>
        <Text>
          Você tem flexibilidade para desistir do financiamento a qualquer
          momento e escolher outro método de pagamento disponível.{' '}
          <ChangePaymentMethodLink href="#" onClick={handleChangePaymentMethod}>
            Clique aqui.
          </ChangePaymentMethodLink>
        </Text>

        <CloseButton kind="ghost" icon="clear" size="small" onClick={close} />
      </TextContainer>
    </Root>
  );
};

export default Alert;
